import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
    APIResponse
} from '../models/models';

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json'
    })
};

@Injectable()
export class ExportHubService {
    constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) {
    }

    public updateQuoteOrder(quoteOrderID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/ExportHub/UpdateQuoteOrder/?quoteOrderID=' + quoteOrderID);
    }

    public updateQuoteOrderLine(quoteOrderLineID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/ExportHub/UpdateQuoteOrderLine/?quoteOrderLineID=' + quoteOrderLineID);
    }

    public updateOrderStop(orderStopID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/ExportHub/UpdateOrderStop/?orderStopID=' + orderStopID);
    }
}